import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { SemanticRuleActionPopupComponent } from './components/semantic-rule-action-popup/semantic-rule-action-popup.component';
import { SemanticRuleListComponent } from './components/semantic-rule-list/semantic-rule-list.component';
import { SemanticRuleAdapter } from './semantic-rule.adapter';
import {
	SemanticRuleEffects,
	semanticRuleReducer,
	SemanticRuleSelector,
	SemanticRuleState,
} from './store';

@NgModule({
	declarations: [SemanticRuleListComponent, SemanticRuleActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		DxDataGridModule,
		NgOptimizedImage,
		FormsModule,
		StoreModule.forFeature(SemanticRuleState.key, semanticRuleReducer),
		EffectsModule.forFeature([SemanticRuleEffects]),
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcButtonModule,
	],
	providers: [SemanticRuleAdapter, SemanticRuleSelector],
})
export class SemanticRuleModule {
	public constructor(private readonly injector: Injector) {
		const semanticRuleListCmpElement = createCustomElement(
			SemanticRuleListComponent,
			{
				injector,
			}
		);
		customElements.define('app-semantic-rule-list', semanticRuleListCmpElement);
	}
}
